import { NxTheme } from "../nx";

export function approvalStatusOf(profile: any): "APPROVED" | "REJECTED" | "PENDING" {
    if (profile?.isApproved === true) return "APPROVED";
    if (profile?.approvalStatus === "REJECTED") return "REJECTED";
    return "PENDING";
}

export function ApprovalNotice({ t, profile }: { t: NxTheme; profile: any }) {
    if (!profile) return null;
    const status = approvalStatusOf(profile);
    if (status === "APPROVED") return null;

    const rejected = status === "REJECTED";

    return (
        <div style={{
            background: rejected ? '#FDECEA' : '#FFF8E1',
            border: `1px solid ${rejected ? '#F5C6C0' : '#FFE082'}`,
            borderRadius: 10, padding: '14px 20px',
            display: 'flex', alignItems: 'flex-start', gap: 12,
        }}>
            <span style={{ fontSize: 20, lineHeight: 1.2 }}>&#9888;</span>
            <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: rejected ? '#B71C1C' : '#E65100' }}>
                    {rejected ? 'Registration Rejected' : 'Registration Pending Approval'}
                </div>
                {rejected ? (
                    <>
                        <div style={{ fontSize: 13, color: '#7F1D1D', marginTop: 4 }}>
                            <strong>Reason:</strong> {profile.rejectionReason || 'No reason was provided.'}
                        </div>
                        <div style={{ fontSize: 13, color: '#7F1D1D', marginTop: 6 }}>
                            Update your details and documents from your profile — your registration goes back for review once you save the changes.
                        </div>
                    </>
                ) : (
                    <div style={{ fontSize: 13, color: '#6D4C00', marginTop: 2 }}>
                        Your registration documents are under review. You will be able to enroll in exams once approved by the admin. The approval process may take 24 to 48 hours.
                    </div>
                )}
            </div>
        </div>
    );
}
